import template from './error-notification.tpl.pug';
import image from './image/error-icon.svg';

class ErrorNotificationController {
    $onChanges(changeObject) {
        if (changeObject.imageUrl) {
            this.imageUrl = changeObject.imageUrl.currentValue || image;
        }
    }
}

export default {
    selector: 'dbAErrorNotification',
    template: template(),
    controller: ErrorNotificationController,
    bindings: {
        title: '<',
        message: '<',
        imageUrl: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/notifications/component/error-notification/error-notification.cmpt.js